import React, { Component } from 'react';

import Modal from './Modal';

export default
  class ExpiredSessionModal extends Component {
    state = {};

    closeModal = () => {
      window.location.href = this.props.redirect
    };

    render() {
      const { open, errorMessage } = this.props;

      return (
        <Modal
          header="Error"
          className="unit-modal"
          open={open}
          onClose={this.closeModal}
        >
          <div className="modal-body">
            <p>{errorMessage}</p>
          </div>
        </Modal>
      );
    }
  }
;



// WEBPACK FOOTER //
// ./src/components/ExpiredSessionModal.js